<template>
    <div class="Layout">
        <web-nav ref="webNav"></web-nav>
        <div class="main-container">
            <router-view />
        </div>
        <bottom ref="bottom"></bottom>
    </div>
</template>

<script>
import webNav from "@/components/webNav";
import bottom from "@/components/bottom"
export default {
    components:{webNav,bottom},
    name: "Layout"
}
</script>

<style scoped lang="scss">
.Layout { min-height: 100vh; display: flex; flex-direction: column; }
.main-container{
    flex: 1;
    background: rgb(245, 246, 249);
    padding-top:20px;
    box-sizing: border-box;
}
</style>
